import { Component, inject } from '@angular/core';
import { ArchiveContextMenuComponent } from 'src/app/features/bizzmine/widgets/context-menu/archive/archive-context-menu.component';
import { ArchiveItemComponent } from 'src/app/shared/components/modals/archive-modal/archive-item/archive-item.component';
import { ModalComponent } from 'src/app/shared/components/modals/modal/modal.component';
import { SkeletonComponent } from '@progress/kendo-angular-indicators';
import { TranslatePipe } from 'src/app/shared/pipes/translate/translate.pipe';
import { AlertComponent } from 'src/app/shared/components/ui/alert/alert.component';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'bizz-edit-questions-warning-modal',
  standalone: true,
  imports: [
    ArchiveContextMenuComponent,
    ArchiveItemComponent,
    ModalComponent,
    SkeletonComponent,
    TranslatePipe,
    AlertComponent
  ],
  templateUrl: './edit-questions-warning-modal.component.html',
  styleUrl: './edit-questions-warning-modal.component.scss'
})
export class EditQuestionsWarningModalComponent {
  public dialogRef = inject(DialogRef);
}
